<button *ngIf="valid"
  class="btn"
  [class.input-group]="isInputGroup"
  [id]="id"
  type="button"
  [ngStyle]="style !== BUTTON_STYLES.TEXT ? {padding: '8px 16px', height: '40px', width: width} : {padding: 0, width: width}"
  [disabled]="disabled"
  (click)="onClick.emit($event)"
  [ngClass]="style === BUTTON_STYLES.STROKE ? 'btn-outline-' + type : style === BUTTON_STYLES.TEXT ? 'btn-link text-' + type : 'btn-' + type"
  [class.add-background-color]="(this.isInputGroup && (this.style === BUTTON_STYLES.STROKE))"
>
  <i [ngStyle]="{'font-size': iconSize}" *ngIf="!useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.LEFT" [ngClass]="icon +  ' icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')"></i> <span *ngIf="!useCustomImage">{{ label }}</span> <i [ngStyle]="{'font-size': iconSize}" *ngIf="!useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.RIGHT" [ngClass]="icon +  ' icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')"></i>
  <img style="padding-bottom: 4px;" [ngStyle]="{height: iconSize}" [src]="icon" *ngIf="useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.LEFT" [ngClass]="'icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')"> <span *ngIf="useCustomImage">{{ label }}</span> <img style="padding-bottom: 4px;" [ngStyle]="{height: iconSize, width: iconSize}" [src]="icon" *ngIf="useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.RIGHT" [ngClass]="'icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')">

</button>

<div *ngIf="!valid" [ngStyle]="{width: width}">
  <button
    class="btn invalid-state"
    [id]="id"
    type="button"
    [ngStyle]="{padding: '8px 16px', height: '40px', width: width}"
    [disabled]="disabled"
    (click)="onClick.emit($event)"
    [ngClass]="'btn-outline-secondary'"
    >
    <i [ngStyle]="{'font-size': iconSize}" *ngIf="!useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.LEFT" [ngClass]="icon +  ' icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')"></i> <span *ngIf="!useCustomImage">{{ label }}</span> <i [ngStyle]="{'font-size': iconSize}" *ngIf="!useCustomImage && icon.trim().length > 0 && iconPosition === ICON_POSITION.RIGHT" [ngClass]="icon +  ' icon-' + iconPosition + ' ' + (label.length === 0 ? 'p-0' : '')"></i>
  </button>
  <div style="margin-top: 8px">
    <p class="error-text m-0">{{errorMessage}}</p>
  </div>
</div>
